<template>
  <v-card-text>
    <v-form ref="form" v-model="valid" v-if="claimSubmission">
      <v-row>
        <v-col cols="12" md="3" lg="2">
          <!-- <v-select
            :menu-props="{ contentClass: 'text-left' }"
            name="coverage-type"
            dense
            outlined
            v-model="claimSubmission.CoverageType"
            :items="coverageTypes"
            class="required"
            :rules="[$rules.required]"
            disabled
            :label="$t('headers.claim_submissions.coverage_type')"
          ></v-select> -->
          {{ claimSubmission.CoverageType }}
        </v-col>
        <template v-if="claimSubmission.CoverageType === 'Dental'">
          <v-col cols="12" md="3" lg="2">
            <auto-select
              autofocus
              :menu-props="{ contentClass: 'text-left' }"
              name="patient"
              dense
              outlined
              v-model="claimSubmission.Patient"
              :items="patients"
              :item-text="
                (item) =>
                  `${item.FirstName} ${item.LastName} (${$helpers.formatDate(
                    item.DateOfBirth
                  )})`
              "
              item-value="Id"
              return-object
              class="required"
              :rules="[$rules.required]"
              :label="$t('components.claims_history.header.patient')"
              :disabled="disabled"
            ></auto-select>
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <auto-select2
              :loading="loading"
              dense
              outlined
              :value.sync="providerValue"
              :items="processedProviders"
              :label="$t('components.claims_history.provider')"
              @add="providerDialog = true"
              :showAddBtn="!providerDisabled"
              class="required"
              :rules="[$rules.required]"
              @keyup="onSearch"
              :search-input="search"
              :disabled="providerDisabled"
              hide-no-data
              placeholder="Search by code or name"
            ></auto-select2>
            <provider-dialog
              :model="providerDialog"
              @close="providerDialog = false"
              @saved="providerAdded"
            />
          </v-col>
        </template>
        <v-col
          cols="12"
          md="3"
          lg="2"
          v-else-if="claimSubmission.CoverageType !== 'SickDay'"
        >
          <auto-select2
            autofocus
            :loading="loading"
            dense
            outlined
            :value.sync="providerValue"
            :items="
              providers.map(
                (o) =>
                  `${o.UniqueId} - ${o.FirstName} ${
                    o.LastName ? o.LastName : ''
                  }`
              )
            "
            :label="$t('components.claims_history.provider')"
            @add="providerDialog = true"
            :showAddBtn="!providerDisabled"
            class="required"
            :rules="[$rules.required]"
            @keyup="onSearch"
            :search-input="search"
            :disabled="providerDisabled"
            hide-no-data
            placeholder="Search by code or name"
          ></auto-select2>
          <provider-dialog
            :model="providerDialog"
            @close="providerDialog = false"
            @saved="providerAdded"
          />
        </v-col>
        <v-col cols="12" md="3" lg="2" v-if="offices && offices.length > 0">
          <auto-select
            :loading="loading"
            dense
            outlined
            :value.sync="claimSubmission.Office"
            :items="offices"
            :label="$t('components.claims_history.office')"
            :item-text="getOfficeText"
            return-object
            class="required"
            :rules="[$rules.required]"
            :disabled="providerDisabled"
          ></auto-select>
        </v-col>
        <v-col
          cols="12"
          md="3"
          lg="2"
          v-if="
            (claimSubmission.CoverageType === 'Dental' ||
              claimSubmission.CoverageType === 'Health' ||
              claimSubmission.CoverageType === 'HSA') &&
            !claimSubmission.IsPredetermined
          "
        >
          <trans-enum
            dense
            outlined
            :value.sync="claimSubmission.Payee"
            :items="options.Enums.Payee"
            :label="$t('components.chequerequisitionform.payee')"
            :class="claimSubmission.IsPredetermined ? '' : 'required'"
            :rules="claimSubmission.IsPredetermined ? [] : [$rules.required]"
            :disabled="payeeDisabled"
          ></trans-enum>
        </v-col>
      </v-row>
    </v-form>
  </v-card-text>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AutoSelect from "../AutoSelect.vue";
import { translate2 } from "@/trans2";
import ProviderDialog from "./ProviderDialog.vue";
import TransEnum from "../TransEnum.vue";
import AutoSelect2 from "../AutoSelect2.vue";
import { tokens } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
export default {
  props: {
    claimSubmission: {
      type: Object,
      default: () => null,
    },
    patients: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    submitted: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    AutoSelect,
    ProviderDialog,
    TransEnum,
    AutoSelect2,
  },
  data() {
    return {
      loading: false,
      valid: false,
      search: null,
      claimType: null,
      coverageTypes: ["Health", "Prescription", "Dental", "HSA", "SickDay"],
      // innerClaim: null,
      providers: [],
      providerDialog: false,
      searchMonitor: null,
      offices: [],
      providerDisabled: false,
      initialized: false,
      telephoneMask: "(###) ### - ####",
      providerValue: null,
      processedProviders: [],
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    payeeDisabled() {
      if (this.claimSubmission === null || this.claimSubmission === undefined) {
        return false;
      }
      if (
        this.claimSubmission.Claims === null ||
        this.claimSubmission.Claims === undefined
      ) {
        return false;
      }
      return (
        this.claimSubmission.Claims.filter(
          (o) => o.State === "PendingPayment" || o.State === "Pended"
        ).length > 0
      );
    },
  },
  async mounted() {
    // console.log("claim header mounted: ", JSON.stringify(this.submitted));
    // console.log("claim header mounted: ", this.claimSubmission.ProviderId);
    // console.log(
    //   "claim header mounted: ",
    //   JSON.stringify(this.claimSubmission.Provider)
    // );
    if (
      this.submitted &&
      this.claimSubmission.ProviderId !== null &&
      this.claimSubmission.ProviderId !== undefined &&
      this.claimSubmission.ProviderId !== "00000000-0000-0000-0000-000000000000"
    ) {
      await this.getProviders(this.claimSubmission.Provider.UniqueId);
      // this.providers = [this.claimSubmission.Provider];
      // this.offices = this.claimSubmission.Provider.ProviderOffices;
      // this.$emit("provider", this.claimSubmission.Provider);
      this.providerDisabled = false;
      // this.claimSubmission.Provider !== null &&
      // this.claimSubmission.Provider !== undefined &&
      // this.disabled;
    }
    console.log("claim header mounted: ", JSON.stringify(this.providers));
    this.$nextTick(async () => {
      if (
        this.submitted &&
        this.claimSubmission.ProviderId !== null &&
        this.claimSubmission.ProviderId !== undefined &&
        this.claimSubmission.ProviderId !==
          "00000000-0000-0000-0000-000000000000"
      ) {
        this.providerValue = `${this.claimSubmission.Provider.UniqueId} - ${
          this.claimSubmission.Provider.FirstName
        } ${
          this.claimSubmission.Provider.LastName
            ? this.claimSubmission.Provider.LastName
            : ""
        }`;
        console.log("claim header mounted NEXT TICK: ", this.providerValue);
      }
      this.initialized = true;
    });
  },
  watch: {
    search: {
      async handler(v) {
        await this.getProviders(v);
      },
      immediate: true,
    },
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
      immediate: true,
    },
    providerValue: {
      handler(v) {
        if (!this.initialized) {
          return;
        }
        if (v !== null && v !== undefined) {
          console.log(JSON.stringify({ a: v }));
          console.log(JSON.stringify(this.providers));
          console.log(JSON.stringify({ s: this.claimSubmission }));
          if (typeof v === "object") {
            this.$nextTick(async () => {
              // await this.getProviders(this.claimSubmission.Provider.UniqueId);
              this.providerValue = `${v.UniqueId} - ${v.FirstName} ${
                v.LastName ? v.LastName : ""
              }`;
            });
            return;
          }
          if (this.providers && this.providers.length > 0) {
            const provider = this.providers.filter(
              (o) =>
                `${o.UniqueId} - ${o.FirstName} ${
                  o.LastName ? o.LastName : ""
                }` === v
            )[0];
            console.log(provider, this.providers, JSON.stringify({ a: v }));
            // this.claimSubmission.ProviderId = provider.Id;
            this.offices = provider.ProviderOffices;
            if (
              this.claimSubmission.OfficeId !== null &&
              this.claimSubmission.OfficeId !== undefined &&
              this.claimSubmission.OfficeId !==
                "00000000-0000-0000-0000-000000000000"
            ) {
              console.log(
                this.claimSubmission.OfficeId,
                JSON.stringify(this.offices)
              );
              this.claimSubmission.Office = this.offices.filter(
                (o) => o.OfficeId === this.claimSubmission.OfficeId
              )[0];
            }
            this.$emit("provider", provider);
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("claims", ["getProvidersForClaimSubmission"]),
    translate2(item, field) {
      return translate2(item, field);
    },
    async onSearch(evt) {
      // console.log(evt.keyCode, evt.target.value);
      if (evt.keyCode >= 37 && evt.keyCode <= 40) {
        return;
      }
      if (evt.keyCode === 13) {
        return;
      }
      const obj = {};
      this.searchMonitor = obj;
      await this.delay(800);
      if (this.searchMonitor !== obj) {
        return;
      }
      this.getProviders(evt.target.value);
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async getProviders(search) {
      if (search === null || search === undefined || search === "") {
        return;
      }
      console.log("provider search: ", search);
      try {
        // Items have already been requested
        if (this.loading) return;
        this.loading = true;
        let coverageType = null;
        if (this.claimSubmission.CoverageType === "Dental") {
          coverageType = "Dental";
        } else if (this.claimSubmission.CoverageType === "Health") {
          coverageType = "Health";
        }
        const providers = (
          await this.getProvidersForClaimSubmission({
            coverageType: coverageType,
            search: search,
          })
        ).data.value;
        this.providers = providers;
        this.processedProviders = providers.map(
          (o) =>
            `${o.UniqueId} - ${o.FirstName} ${o.LastName ? o.LastName : ""}`
        );
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async providerAdded(provider) {
      // console.log("provider added: ", provider);
      this.providerDialog = false;
      await this.getProviders(provider.UniqueId);
      this.claimSubmission.Provider = this.providers.filter(
        (o) => o.UniqueId === provider.UniqueId
      )[0];
      // console.log(JSON.stringify(this.claimSubmission.Provider), this.claimSubmission.Provider)
      this.offices = provider.ProviderOffices;
      this.$emit("provider", provider);
    },
    getOfficeText(item) {
      let ret = item.Office.OfficeNumber;
      if (
        item.PrimaryContactFirstName !== null &&
        item.PrimaryContactFirstName !== undefined
      ) {
        ret += ` - ${item.PrimaryContactFirstName}`;
      }
      if (
        item.PrimaryContactLastName !== null &&
        item.PrimaryContactLastName !== undefined
      ) {
        ret += ` ${item.PrimaryContactLastName}`;
      }
      if (item.WorkPhone !== null && item.WorkPhone !== undefined) {
        ret += `, ${this.mask(item.WorkPhone)}`;
      }
      if (item.Fax !== null && item.Fax !== undefined) {
        ret += `, ${this.mask(item.Fax)}`;
      }
      if (item.Office.Address1 !== null && item.Office.Address1 !== undefined) {
        ret += `, ${item.Office.Address1}`;
      }
      if (item.Office.Address2 !== null && item.Office.Address2 !== undefined) {
        ret += ` ${item.Office.Address2}`;
      }
      if (item.Office.Address3 !== null && item.Office.Address3 !== undefined) {
        ret += ` ${item.Office.Address3}`;
      }
      if (item.Office.City !== null && item.Office.City !== undefined) {
        ret += ` ${item.Office.City}`;
      }
      if (
        item.Office.PostalCode !== null &&
        item.Office.PostalCode !== undefined
      ) {
        ret += ` ${item.Office.PostalCode}`;
      }
      if (item.Office.Province !== null && item.Office.Province !== undefined) {
        ret += ` ${item.Office.Province.Code}`;
      }
      return ret;
    },
    mask(v, mask) {
      if (v) {
        return masker(v, mask, true, tokens);
      }
      return v;
    },
  },
};
</script>
